import { DesignTokenSizeEnum, } from './definitions';
import { fonts, mainThemeColors, invertedThemeColors, appearances, } from '@volkswagen-onehub/tokens';
/**
 * This map contains values to be used with sizes and spacings.
 */
const sizesAndSpacings = Object.keys(DesignTokenSizeEnum).reduce((acc, key) => {
    acc[key] = `size.${key}`;
    return acc;
}, {
    line: {
        default: 'size.line100',
        active: 'size.line200',
    },
    border: {
        light: 'size.line100',
        heavy: 'size.line200',
    },
});
/**
 * Set of available UI themes
 *
 * "main" theme must be a complete UI theme, all other themes defined here can be
 * a partial definition, missing values will be inherited from "main"
 */
const main = {
    animation: {
        timingFunction: {
            in: 'animation.timingFunction.timing100',
            out: 'animation.timingFunction.timing100',
            linear: 'animation.timingFunction.timing200',
            cubicOut: 'animation.timingFunction.timing300',
            navigation: 'animation.timingFunction.timing400',
        },
        duration: {
            collapsible: 'animation.duration.duration600',
            color: 'animation.duration.duration300',
            layer: 'animation.duration.duration300',
            scrollIndicator: 'animation.duration.duration2000',
            nba: 'animation.duration.duration300',
            tabIndicator: 'animation.duration.duration300',
            statusIndicator: 'animation.duration.duration400',
        },
    },
    size: sizesAndSpacings,
    shadows: {
        variant1: 'shadows.variant1',
        variant2: 'shadows.variant2',
        variant3: 'shadows.variant3',
        variant4: 'shadows.variant4',
    },
    fonts: fonts,
    appearances: appearances,
    colors: mainThemeColors,
};
const inverted = {
    colors: invertedThemeColors,
};
export const themeSet = {
    main,
    inverted,
};
